<!-- <app-caricamento *ngIf="loading"></app-caricamento> -->
<app-caricamento-visite *ngIf="loading"></app-caricamento-visite>
<div *ngIf="checkAbilitato && abilitato && !loading" class="w-100">
  <app-tipi-visite-layout-base
    [tipivisite]="tipivisite"
    [linguaCorrente]="linguaCorrente"
    [codiceForm]="codiceForm"
    [cart]="carrello"
    [collegate]="false"
    *ngIf="layout == 1"
  ></app-tipi-visite-layout-base>
  <app-tipi-visite-layout-colonne
    [tipivisite]="tipivisite"
    [linguaCorrente]="linguaCorrente"
    [codiceForm]="codiceForm"
    [cart]="carrello"
    [collegate]="false"
    [base]="false"
    *ngIf="layout == 2"
  ></app-tipi-visite-layout-colonne>
</div>
<div *ngIf="checkAbilitato && !abilitato && !loading">
  <app-disabilitato [pagina]="'visite'"></app-disabilitato>
</div>
